module.exports = __webpack_public_path__ + "img/google-wallet-pc.b6ab4c37.jpg";